<template>
  <div class="reporting">
    <h6 class="reporting__title">
      {{ $t('wellbeingSale.reporting.title1') }}
    </h6>

    <p class="reporting__paragraphUnderTitle">
      {{ $t('wellbeingSale.reporting.paragraph1') }}
    </p>

    <p class="reporting__paragraph2">
      {{ $t('wellbeingSale.reporting.paragraph2') }}
    </p>

    <picture>
      <source
        media="(max-width: 767px)"
        srcset="/images/wellbeing-sale/reporting/frame.png"
      >
      <source
        media="(min-width: 768px)"
        srcset="/images/wellbeing-sale/reporting/frame-desktop.png"
      >
      <img
        class="reporting__img"
        src="/images/wellbeing-sale/reporting/frame.png"
        alt="Chris standing up holding his daughter Elva"
      >
    </picture>

    <h6 class="reporting__title">
      {{ $t('wellbeingSale.reporting.title2') }}
    </h6>

    <p class="reporting__paragraphUnderTitle">
      {{ $t('wellbeingSale.reporting.paragraph5') }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.reporting {
  display: flex;
  flex-direction: column;
  max-width: 136rem;
  margin: auto;
  padding: 5rem 2.6rem;

  &__title {
    @include h8;
    padding-bottom: 2.4rem;
    color: $text-400;
    text-align: center;
  }

  &__paragraphUnderTitle {
    @include h10;
    padding-bottom: 2.4rem;
    color: $text-400;
    text-align: center;
  }

  &__paragraph2 {
    @include body-1-medium;
    padding-bottom: 3.2rem;
    color: $text-300;
    text-align: center;
  }

  &__img {
    padding-bottom: 2.4rem;
    border-radius: 1.6rem;
  }
  
  @include atXS {
    width: 90%;
  }

  @include atS {
    padding: 10rem 0;

    &__title {
      @include h6;
      width: 60%;
      margin: auto;
      padding-bottom: 3.2rem;
    }

    &__paragraphUnderTitle {
      @include h9;
      width: 70%;
      margin: auto;
      padding-bottom: 3.2rem;
    }

    &__paragraph2 {
      @include body-1-medium;
      width: 70%;
      margin: auto;
      padding-bottom: 3.2rem;
    }

    &__img {
      padding-bottom: 3.2rem;
    }
  }

  @include atL {
    width: 100%
  }
}

</style>
